import { MarketingLayout } from "@/components/MarketingLayout";
import { PageHeader } from "@/components/ui/PageHeader";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";

export default function PricingPage() {
  return (
    <MarketingLayout>
      <PageHeader
        title="Reputation monitoring,"
        accent="priced like software."
        subtitle="Always-on monitoring, policy detection, appeal generation, and alerts. Managed filing is available for eligible brands with verified Brand Registry access."
      />
      <Pricing hideHeader />
      <FAQ hideHeader />
    </MarketingLayout>
  );
}
